import React from 'react';
import IExchangeSummary from './IExchangeSummary';
import Big from 'big.js';
import ToolTip from '@appComponents/ToolTip/ToolTip';
import CurrencyElement from '@appComponents/CurrencyElement/CurrencyElement';
import * as style from './ExchangeSummaryStyle.module.scss'
import SummaryTable, { SummaryTableRow } from '@appComponents/SummaryTable/SummaryTable';
import { IGetStringKey } from '@appInterfaces/general.types';
import { renameMainCurrency } from '@features/utils/functions';

const ExchangeSummary: React.FunctionComponent<IExchangeSummary> = (props) => {
  const approxLabels:IGetStringKey = {
    incomeAmount: `Amount of ${renameMainCurrency(props.incomeCurrency).toUpperCase()}${''
      } to ${props.type === 'sell' ? 'receive' : 'buy'} (approx.):`,
    outcomeAmount: `Amount of ${renameMainCurrency(props.outcomeCurrency).toUpperCase()} to ${props.type}:`,
    fee: 'Transaction Fee:',
    exchangeRate: `Exchange Rate (approx.)`,
  };
  const labels:IGetStringKey = {
    incomeAmount: `Amount of ${props.type === 'sell' ? 'received' : 'bought'}${''
      } ${renameMainCurrency(props.incomeCurrency).toUpperCase()}:`,
    outcomeAmount: `Amount of ${props.type === 'sell' ? 'sold' : 'traded'}${''
      } ${renameMainCurrency(props.outcomeCurrency).toUpperCase()}:`,
    fee: 'Transaction Fee:',
    exchangeRate: `Exchange Rate`,
  };

  const getLabels = props.isApprox ? approxLabels : labels;

  const displayRow = (key: number, label: string, value: number | string, highlighted: boolean = false) => {
    const className = highlighted ? style.highlighted : undefined;

    return label && value ? (
      <SummaryTableRow key={key} label={getLabels[label]} value={formatValue(label, value)} className={className}/>
    ) : null;
  };

  const formatValue = (label: string, value: string | number) => {
    switch (label) {
      case 'outcomeAmount':
        return (
          <CurrencyElement
            value={value}
            currency={props.outcomeCurrency}
          />
        );
      case 'incomeAmount':
        return (
          <CurrencyElement
            value={value}
            currency={props.incomeCurrency}
          />
        );
      case 'fee':
        return (
          <CurrencyElement
            value={value}
            currency={props.outcomeCurrency}
          />
        );
      case 'exchangeRate':
        const roundedValue = Big(value).round(8, 0);
        return (
          <>
            <CurrencyElement
              value={1}
              currency={props.currency}
            />
            ~
            <CurrencyElement
              value={value}
              currency={props.selectCurrency}
            />
            <ToolTip
              maxWidth={300}
              text={
                <>
                  {roundedValue.toString()}
                  <span className={style.currency}> {renameMainCurrency(props.selectCurrency)}</span>
                </>
              }
            >
              &nbsp; &#9432;
            </ToolTip>
          </>
        );
      default:
        return value;
    }
  };

  const renderAmount = () => props.type === 'sell'
    ? (
      <>
        {displayRow(1, 'outcomeAmount', props.outcomeAmount, true)}
        {displayRow(0, 'incomeAmount', props.incomeAmount)}
      </>
    ) : (
      <>
        {displayRow(0, 'incomeAmount', props.incomeAmount, true)}
        {displayRow(1, 'outcomeAmount', props.outcomeAmount)}
      </>
    );

  return (
    <SummaryTable>
      {renderAmount()}
      {displayRow(2, 'fee', props.fee)}
      {displayRow(3, 'exchangeRate', props.exchangeRate)}
    </SummaryTable>
  );
};

export default ExchangeSummary;
